import {Injectable, Injector} from "@angular/core";

import {BaseListService} from "app/services/domain/base.service";
import * as Models from "app/services/proxy/model/models";

@Injectable()
export class TagBaselineAvailableTagsListService extends BaseListService<Models.TagBaselineAvailableTagListRequest, Models.TagBaselineAvailableTagBatchRequest, Models.TagBaselineAvailableTag>
{
    constructor(inj: Injector)
    {
        super(inj, Models.TagBaselineAvailableTag);
    }

    public list(listReq: Models.TagBaselineAvailableTagListRequest): Promise<Models.ListResponse>
    {
        return this.domain.apis.tagBaselineDefinitionsApi.availableTagsList(listReq);
    }

    protected getBatchResponseImpl(req: Models.TagBaselineAvailableTagBatchRequest): Promise<Models.TagBaselineAvailableTagBatchResponse>
    {
        return this.domain.apis.tagBaselineDefinitionsApi.availableTagsBatch(req);
    }

    protected createBatchRequest(listReq: Models.TagBaselineAvailableTagListRequest,
                                 ids: string[]): Models.TagBaselineAvailableTagBatchRequest
    {
        return Models.TagBaselineAvailableTagBatchRequest.newInstance({
                                                                          ids    : ids,
                                                                          filters: listReq.filters?.filters
                                                                      });
    }

    public async getTagValues(tenants: string[],
                              cloudAccounts: string[],
                              tagKeys: string[]): Promise<Models.TagBaselineAvailableTag[]>
    {
        const accountFilter = Models.AccountFilters.newInstance({
                                                                    tenants       : tenants,
                                                                    cloud_accounts: cloudAccounts
                                                                });

        const request = Models.TagBaselineAvailableTagBatchRequest.newInstance({
                                                                                   filters: accountFilter,
                                                                                   ids    : tagKeys
                                                                               });

        const results = await this.app.domain.apis.tagBaselineDefinitionsApi.availableTagsBatch(request);
        return tagKeys.map((t) => results.results[t]);
    }
}
